import React from "react";
import {
  FiTruck, FiActivity, FiAlertTriangle, FiDollarSign,
  FiDroplet, FiMapPin, FiCpu, FiTrendingUp,
} from "react-icons/fi";
import { HealthRing, KpiCard, SeverityBadge, healthColor, severityColor } from "./fleetHelpers";

const FleetOverviewPanel = ({ d }) => {
  const s = d.summary;
  const maxFuel = Math.max(...d.weeklyKpi.map(k => k.trips));

  return (
    <div className="fleet-overview">

      {/* ── Row 1: Health Score + KPI Cards ── */}
      <div className="fo-top-row">

        {/* Health Score Ring */}
        <div className="fo-health-card">
          <div className="fo-health-ring-wrap">
            <HealthRing value={s.fleetHealthScore} size={120} stroke={12} />
            <div className="fo-health-center">
              <span className="fo-health-num" style={{ color: healthColor(s.fleetHealthScore) }}>{s.fleetHealthScore}</span>
              <span className="fo-health-lbl">Fleet Health</span>
            </div>
          </div>

          {/* Vehicle status breakdown */}
          <div className="fo-status-grid">
            <div className="fo-status-item fo-active">
              <span className="fo-status-num">{s.active}</span>
              <span className="fo-status-lbl">Active</span>
            </div>
            <div className="fo-status-item fo-idle">
              <span className="fo-status-num">{s.idle}</span>
              <span className="fo-status-lbl">Idle</span>
            </div>
            <div className="fo-status-item fo-maint">
              <span className="fo-status-num">{s.maintenance}</span>
              <span className="fo-status-lbl">Service</span>
            </div>
            <div className="fo-status-item fo-offline">
              <span className="fo-status-num">{s.offline}</span>
              <span className="fo-status-lbl">Offline</span>
            </div>
          </div>
        </div>

        {/* KPI Grid */}
        <div className="fo-kpi-grid">
          <KpiCard label="Total Vehicles"    value={s.totalVehicles}       color="#667eea" icon={FiTruck}       sub={`${s.onRoute} on route`} />
          <KpiCard label="Distance Today"    value={s.distanceToday}       unit="km"       color="#10b981" icon={FiMapPin}      sub="Across fleet" />
          <KpiCard label="Trips Completed"   value={s.tripsCompletedToday} color="#3b82f6" icon={FiActivity}    sub={`${s.tripsInProgress} in progress`} />
          <KpiCard label="Fuel Consumed"     value={s.fuelToday}           unit="L"        color="#f59e0b" icon={FiDroplet}     sub={`₹${(s.fuelToday * 15.5).toLocaleString()}`} />
          <KpiCard label="Cost Today"        value={`₹${(s.costToday/1000).toFixed(1)}k`} color="#ec4899" icon={FiDollarSign}  sub={`₹${(s.costMonth/1000).toFixed(0)}k / month`} />
          <KpiCard label="CO₂ Emissions"     value={s.co2Today}            unit="t"        color="#8b5cf6" icon={FiTrendingUp}  sub="Today" />
          <KpiCard label="Avg Speed"         value={s.avgSpeedFleet}       unit="km/h"     color="#0ea5e9" icon={FiActivity}    sub="Fleet average" />
          <KpiCard label="Utilization"       value={`${s.utilizationPct}%`}               color="#06b6d4" icon={FiTruck}       sub="Fleet utilization" />
        </div>
      </div>

      {/* ── Row 2: AI Insights + Alerts + Weekly KPI ── */}
      <div className="fo-bottom-row">

        {/* AI Insights */}
        <div className="fo-ai-card">
          <div className="fo-card-title">
            <FiCpu size={16} /> AI Insights
          </div>
          <div className="fo-ai-list">
            {s.aiInsights.map((msg, i) => (
              <div key={i} className="fo-ai-item">
                <span className="fo-ai-dot" />
                {msg}
              </div>
            ))}
          </div>
        </div>

        {/* Active Alerts */}
        <div className="fo-alerts-card">
          <div className="fo-card-title">
            <FiAlertTriangle size={16} /> Active Alerts
            <span className="fo-alert-count-chip" style={{ background: "#fee2e2", color: "#ef4444" }}>
              {s.criticalAlerts} Critical
            </span>
          </div>
          <div className="fo-alerts-list">
            {d.alerts.slice(0, 6).map(a => (
              <div key={a.id} className="fo-alert-row">
                <div className="fo-alert-dot" style={{ background: severityColor(a.severity) }} />
                <div className="fo-alert-info">
                  <span className="fo-alert-vehicle">{a.vehicle}</span>
                  <span className="fo-alert-msg">{a.message}</span>
                </div>
                <SeverityBadge severity={a.severity} />
              </div>
            ))}
          </div>
        </div>

        {/* Weekly KPI trend */}
        <div className="fo-weekly-card">
          <div className="fo-card-title"><FiTrendingUp size={16} /> Weekly Trips</div>
          <div className="fo-bar-chart">
            {d.weeklyKpi.map(k => (
              <div key={k.d} className="fo-bar-col">
                <div className="fo-bar-wrap">
                  <div
                    className="fo-bar"
                    style={{ height: `${(k.trips / maxFuel) * 100}%`, background: "#667eea" }}
                    title={`${k.trips} trips`}
                  />
                </div>
                <span className="fo-bar-label">{k.d}</span>
                <span className="fo-bar-val">{k.trips}</span>
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default FleetOverviewPanel;
